import React,{ 
    useEffect,
    forwardRef,
} from 'react'
import useList from '@/hooks/list'
import {
    Select,
} from "antd";
const { Option } = Select;

const Index = forwardRef((props,ref)=>{
    const {
        getRentTypeList,
        rentTypeList,
        setRentTypeList
    } = useList()

    useEffect(() => {
        init()
    },[]);
    const init = async ()=>{
        setRentTypeList([])
        getRentTypeList()
    }
    return (
        <Select
            placeholder="请选择"
            allowClear
            style={{ width: "100%" }}
            {...props}
        >
            {
                rentTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
            }
        </Select>
    )
})

export default Index